/**
 * Fan-out for feed-review undo so local paginated lists (feed page, booking
 * activity) can restore rows the shared `FeedContext` does not own.
 */

type FeedReviewUndoListener = (ids: string[]) => void;

const listeners = new Set<FeedReviewUndoListener>();

export function subscribeFeedReviewUndo(
  listener: FeedReviewUndoListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitFeedReviewUndo(ids: string[]): void {
  if (ids.length === 0) return;
  for (const listener of listeners) listener(ids);
}
